"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EchoTypesTectonicCoreFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "a",
                type: "address",
            },
        ],
        name: "addresses",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address payable",
                name: "unitroller",
                type: "address",
            },
        ],
        name: "becomeBrains",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "bool",
                name: "b",
                type: "bool",
            },
        ],
        name: "booly",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256[]",
                name: "u",
                type: "uint256[]",
            },
        ],
        name: "listOInts",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingTectonicCoreImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "reverty",
        outputs: [],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "string",
                name: "s",
                type: "string",
            },
        ],
        name: "stringy",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tectonicCoreImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class EchoTypesTectonicCoreFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.EchoTypesTectonicCoreFactory = EchoTypesTectonicCoreFactory;
EchoTypesTectonicCoreFactory.bytecode = _bytecode;
EchoTypesTectonicCoreFactory.abi = _abi;
//# sourceMappingURL=EchoTypesTectonicCoreFactory.js.map